import { createUseStyles } from '@pushpay/styles';
import { getButtonColor } from '../button-color';
export const useSaveButtonStyles = createUseStyles(theme => {
  const buttonColor = getButtonColor(theme);
  return {
    root: {
      width: '9em',
      backgroundColor: buttonColor.PRIMARY.DEFAULT.BACKGROUND
    },
    saving: {
      '&:disabled': {
        '&, &:hover': {
          height: '2.5em',
          padding: 0,
          pointerEvents: 'none',
          backgroundColor: buttonColor.PRIMARY.DISABLED.BACKGROUND,
          color: buttonColor.PRIMARY.DISABLED.COLOR,
          border: `1px solid ${theme.colors['color-border-surface']}`
        }
      }
    },
    icon: {
      fontSize: '1em',
      marginRight: theme.SPACING.GUTTER
    },
    success: {
      '&:disabled': {
        '&, &:hover': {
          pointerEvents: 'none',
          color: theme.colors['palette-white'],
          backgroundColor: theme.colors['palette-green'],
          borderColor: theme.colors['palette-green'],
          position: 'relative'
        }
      }
    }
  };
});